/**
 * MeasurementCalculator.config.js
 *
 * Static configuration for the Measurement Calculator tool.
 * Controls copy, fields, and category-specific behavior.
 */

const MeasurementCalculatorConfig = {
  id: "measurementCalculator",

  title: "Project Measurement Calculator",

  description:
    "Enter a few measurements to estimate the size of your project.",

  ctaLabel: "Calculate Measurements",

  /**
   * Default form values
   */
  defaults: {},

  /**
   * Default fields (used if no category override exists)
   */
  fields: [
    {
      name: "length",
      label: "Length",
      type: "number",
      placeholder: "Enter length",
      unit: "ft",
    },
    {
      name: "width",
      label: "Width",
      type: "number",
      placeholder: "Enter width",
      unit: "ft",
    },
  ],

  /**
   * Category-specific overrides
   */
  categoryOverrides: {
    flooring: {
      fields: [
        {
          name: "length",
          label: "Room Length",
          type: "number",
          placeholder: "Length (ft)",
          unit: "ft",
        },
        {
          name: "width",
          label: "Room Width",
          type: "number",
          placeholder: "Width (ft)",
          unit: "ft",
        },
      ],
    },

    fencing: {
      fields: [
        {
          name: "perimeter",
          label: "Total Fence Length",
          type: "number",
          placeholder: "Linear feet",
          unit: "ft",
        },
      ],
    },

    "window-replacement": {
      fields: [
        {
          name: "windowCount",
          label: "Number of Windows",
          type: "number",
          placeholder: "Total windows",
          unit: "count",
        },
      ],
    },

    decking: {
      fields: [
        {
          name: "deckLength",
          label: "Deck Length",
          type: "number",
          placeholder: "Length (ft)",
          unit: "ft",
        },
        {
          name: "deckWidth",
          label: "Deck Width",
          type: "number",
          placeholder: "Width (ft)",
          unit: "ft",
        },
      ],
    },

    stairlifts: {
      fields: [
        {
          name: "stairs",
          label: "Number of Steps",
          type: "number",
          placeholder: "Step count",
          unit: "count",
        },
      ],
    },
  },
};

export default MeasurementCalculatorConfig;
